(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animated-mark"] && !Shopify.designMode) return;
  try {
    class AnimatedMark extends HTMLElement {
    connectedCallback() {
      this.svg = this.querySelector('.animated-mark__svg');
      if (!this.svg || typeof this.svg.pauseAnimations !== 'function') return;
      this.svg.pauseAnimations();
      this.svg.setCurrentTime(0);
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.svg.setCurrentTime(0);
          this.svg.unpauseAnimations();
        },
        { threshold: 1 }
      );
      this.observe = () => this.observer.observe(this);
      if (document.readyState === 'complete') {
        this.observe();
      } else {
        window.addEventListener('load', this.observe, { once: true });
      }
    }

    disconnectedCallback() {
      if (this.observe) window.removeEventListener('load', this.observe);
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('animated-mark')) {
    customElements.define('animated-mark', AnimatedMark);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-items"] && !Shopify.designMode) return;
  try {
    class CartForm extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onAdded = this.onAdded.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      if (this.hasAttribute('data-cart-page')) document.addEventListener('cart:added', this.onAdded);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      document.removeEventListener('cart:added', this.onAdded);
      if (this.controller) this.controller.abort();
    }

    async onAdded() {
      this.setAttribute('aria-busy', 'true');
      try {
        await this.refresh();
        this.announce(this.dataset.updatedLabel);
      } catch (error) {
        this.announce(this.dataset.errorLabel);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    onClick(event) {
      const step = event.target.closest ? event.target.closest('[data-step]') : null;
      if (step) {
        const input = this.querySelector('[data-quantity][data-line="' + step.dataset.line + '"]');
        const current = input ? parseInt(input.value, 10) || 0 : 0;
        const next = Math.max(0, current + parseInt(step.dataset.step, 10));
        this.change(step.dataset.line, next, '[data-step="' + step.dataset.step + '"][data-line="' + step.dataset.line + '"]');
        return;
      }

      const remove = event.target.closest ? event.target.closest('[data-remove]') : null;
      if (!remove) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      this.change(remove.dataset.line, 0);
    }

    onChange(event) {
      const input = event.target.closest ? event.target.closest('[data-quantity]') : null;
      if (!input) return;
      const value = Math.max(0, parseInt(input.value, 10) || 0);
      this.change(input.dataset.line, value, '[data-quantity][data-line="' + input.dataset.line + '"]');
    }

    async change(line, quantity, focusSelector) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.setAttribute('aria-busy', 'true');
      this.announce(this.dataset.loadingLabel);

      try {
        const response = await fetch(this.dataset.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: Number(line),
            quantity: quantity,
            sections: this.dataset.sectionId,
            sections_url: window.location.pathname
          }),
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error(String(response.status));

        const cart = await response.json();
        const html = cart.sections ? cart.sections[this.dataset.sectionId] : null;
        if (html) {
          this.render(html);
        } else {
          await this.refresh();
        }
        this.updateCount(cart.item_count);
        this.announce(this.dataset.updatedLabel);

        if (focusSelector) {
          const target = this.querySelector(focusSelector);
          if (target) target.focus();
        }
        this.dispatchEvent(new CustomEvent('cart:changed', { bubbles: true, detail: cart }));
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.announce(this.dataset.errorLabel);
        try {
          await this.refresh();
        } catch (refreshError) {
          window.location.assign(this.dataset.cartUrl);
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    async refresh() {
      const url = new URL(this.dataset.cartUrl, window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(String(response.status));
      this.render(await response.text());
      this.updateCount(this.dataset.count);
    }

    render(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('cart-form');
      const freshContent = fresh ? fresh.querySelector('[data-cart-content]') : null;
      const content = this.querySelector('[data-cart-content]');
      if (!freshContent || !content) return;

      content.replaceChildren(...Array.from(freshContent.childNodes));
      this.dataset.count = fresh.dataset.count || '0';
      content.dispatchEvent(new CustomEvent('reveal:scan', { bubbles: true }));
    }

    updateCount(count) {
      const text = String(count);
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = text;
      });

      const label = this.dataset.cartLabel;
      if (!label) return;
      document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
        el.textContent = label.replace('__count__', text);
      });
    }

    announce(text) {
      const status = this.querySelector('[data-cart-status]');
      if (!status || !text) return;
      status.textContent = '';
      window.requestAnimationFrame(() => {
        status.textContent = text;
      });
    }
  }

  if (!customElements.get('cart-form')) {
    customElements.define('cart-form', CartForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.media > video[autoplay]').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.setAttribute('controls', 'controls');
      video.pause();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form[data-quick-add]');
      this.variantInput = this.form ? this.form.querySelector('input[name="id"]') : null;
      this.button = this.form ? this.form.querySelector('[data-add]') : null;
      this.optionLabel = this.querySelector('[data-option-label]');
      this.priceText = this.querySelector('[data-price-text]');
      this.compare = this.querySelector('[data-compare]');
      this.compareText = this.querySelector('[data-compare-text]');
      this.saleLabel = this.querySelector('[data-sale-label]');
      this.status = this.querySelector('[data-status]');
      this.addEventListener('change', this.onChange);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.controller) this.controller.abort();
      clearTimeout(this.addedTimer);
    }

    onChange(event) {
      const input = event.target.closest ? event.target.closest('input[data-swatch]') : null;
      if (!input) return;

      if (this.variantInput) this.variantInput.value = input.dataset.variantId;
      if (this.optionLabel) this.optionLabel.textContent = input.dataset.optionLabel;
      if (this.priceText) this.priceText.textContent = input.dataset.price;

      const compare = input.dataset.comparePrice || '';
      if (this.compare) {
        this.compare.hidden = compare === '';
        if (this.compareText) this.compareText.textContent = compare;
      }
      if (this.saleLabel) this.saleLabel.hidden = compare === '';
      if (this.button) this.button.disabled = input.dataset.available !== 'true';
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;
      if (this.button) this.button.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();

      const url = new URL(this.form.action, window.location.href);
      url.pathname = url.pathname.replace(/\/?$/, '.js');

      try {
        const response = await fetch(url.toString(), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error(String(response.status));

        await this.updateCartCount();
        this.announce(this.dataset.addedLabel);
        this.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));

        if (this.button) {
          this.button.classList.add('is-added');
          clearTimeout(this.addedTimer);
          this.addedTimer = setTimeout(() => this.button.classList.remove('is-added'), 1500);
        }
      } catch (error) {
        if (error.name !== 'AbortError') this.form.submit();
      } finally {
        this.loading = false;
        if (this.button) this.button.removeAttribute('aria-busy');
      }
    }

    async updateCartCount() {
      const response = await fetch(this.dataset.cartUrl, {
        headers: { Accept: 'application/json' },
        signal: this.controller.signal
      });
      if (!response.ok) return;

      const cart = await response.json();
      const count = String(cart.item_count);
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
      });

      const label = this.dataset.cartLabel;
      if (!label) return;
      document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
        el.textContent = label.replace('__count__', count);
      });
    }

    announce(text) {
      if (!this.status || !text) return;
      this.status.textContent = '';
      window.requestAnimationFrame(() => {
        this.status.textContent = text;
      });
    }
  }

  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-progress"] && !Shopify.designMode) return;
  try {
    class ScrollProgress extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.scroller = this.querySelector('[data-scroller]');
      this.bar = this.querySelector('[data-bar]');
      if (!this.scroller || !this.bar) return;

      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.scroller);
      } else {
        window.addEventListener('resize', this.onResize, { passive: true });
      }

      this.onResize();
    }

    disconnectedCallback() {
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.onScroll);
      }
      if (this.observer) {
        this.observer.disconnect();
      }
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      const overflows = this.scroller.scrollWidth > this.scroller.clientWidth + 1;
      this.bar.hidden = !overflows;
      this.update();
    }

    onScroll() {
      this.update();
    }

    update() {
      const total = this.scroller.scrollWidth || 1;
      this.style.setProperty('--bar-size', this.scroller.clientWidth / total);
      this.style.setProperty('--bar-offset', this.scroller.scrollLeft / total);
    }
  }

  if (!customElements.get('scroll-progress')) {
    customElements.define('scroll-progress', ScrollProgress);
  }
  } catch(e) { console.error(e); }
})();

})();
